module.exports = __webpack_public_path__ + "img/developersteve-smc.0ead3b48.jpg";